  "use client";
  import { useIntl } from "react-intl";
  import { CallToActionVariant1, CallToActionVariant2 } from "./variants";
  import { track } from "@/lib/productAnalytics";

  enum Variants {
    First = "option-1",
    Second = "option-2",
  }

  const Options = {
    [Variants.First]: CallToActionVariant1,
    [Variants.Second]: CallToActionVariant2,
  };

  export default function CallToActionV2({
    option = Variants.First,
  }: {
    option?: "option-1" | "option-2";
  }) {
    const intl = useIntl();
    const CurrentVariant = Options[option];
    const locale = intl.locale === "en" ? "en" : "es";
    const contactHref = `/${locale}/${intl.formatMessage({ id: "path_contact" })}`;

    const trackContactCta = () => {
      track("cta_clicked", {
        cta_name: "legacy_public_contact",
        feature_area: "landing",
        landing_id: "public_pages",
        success: true,
      });
    };

    return (
      <section className="container py-12">
        <CurrentVariant
          title={intl.formatMessage({ id: "call_to1" })}
          content={intl.formatMessage({ id: "call_to2" })}
          btnText={intl.formatMessage({ id: "call_to4" })}
          href={contactHref}
          onClick={trackContactCta}
        />
      </section>
    );
  }
